import { COMMERCE_BACKEND_CCP, COMMERCE_BACKEND_HAMS } from '@atlassian/commerce-ui/rollout';

import type { CommerceBackendName } from './useCommerceBackendName.ts';

export interface BuildBillingDetailsUrlsParams {
	cloudId?: string;
	commerceBackendName?: CommerceBackendName;
	entitlementId?: string;
	environment?: string;
	invoiceGroupId?: string;
	transactionAccountId?: string;
}

const ENV_URLS = {
	PRODUCTION: 'https://admin.atlassian.com',
	STAGING: 'https://admin.stg.atlassian.com',
};

export const buildChangePlanUrl = (params: BuildBillingDetailsUrlsParams): string => {
	const { cloudId, commerceBackendName, entitlementId, environment, transactionAccountId } = params;
	const CLOUD_ADMIN_URL = ENV_URLS[environment ?? 'PRODUCTION'];

	if (commerceBackendName === COMMERCE_BACKEND_HAMS && cloudId) {
		return `${CLOUD_ADMIN_URL}/s/${cloudId}/billing/applications`;
	}
	if (commerceBackendName === COMMERCE_BACKEND_CCP && transactionAccountId) {
		if (entitlementId) {
			return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}`;
		}
		return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}`;
	}

	return `${CLOUD_ADMIN_URL}/billing`;
};

export const buildPaymentFlowUrl = (params: BuildBillingDetailsUrlsParams): string => {
	const { cloudId, commerceBackendName, environment, invoiceGroupId, transactionAccountId } =
		params;
	const CLOUD_ADMIN_URL = ENV_URLS[environment ?? 'PRODUCTION'];

	if (commerceBackendName === COMMERCE_BACKEND_HAMS && cloudId) {
		return `${CLOUD_ADMIN_URL}/s/${cloudId}/billing/paymentdetails/add`;
	}
	if (commerceBackendName === COMMERCE_BACKEND_CCP && transactionAccountId) {
		if (invoiceGroupId) {
			return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/${invoiceGroupId}/payment-flow?referrer=confluence`;
		}
		return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}`;
	}
	return `${CLOUD_ADMIN_URL}/billing`;
};
